import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as actions from "../../../store/actions";

import { VALIDATE_TEMPLATE } from "../../../store/actions/actionTypes";

import AppointmentIcon from "../../../components/uiElements/icons/profileIcons/AppointmentIcons";
import Button from "../../../components/formElements/button/Button";
import CustomTextArea from "../../../components/formElements/customTextArea/CustomTextArea";

const CreateNoteTemplate = ({
  history,
  templates,
  addTemplate,
  form,
  setTemplateData,
  validateData,
  clearTemplateData,
}) => {
  useEffect(() => {
    if (form && form.templatesValid) {
      addTemplate(() => {
        history.goBack();
      });
    }

    form.templatesValid = false;
    // eslint-disable-next-line
  }, [form]);

  useEffect(() => {
    clearTemplateData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="text-dark">
        <p className="h3">
          <AppointmentIcon
            type="leftArrow"
            className="back-button"
            onClick={() => {
              history.goBack();
              clearTemplateData();
            }}
          />
          <span className="ml-1 h4 text-dark ">Create Note</span>
        </p>
      </div>

      <div className="note-template-container">
        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Note Name"
            value={templates?.note_name || ""}
            className="mycontentdivMain"
            error={form.note_name}
            onChange={val => setTemplateData({ note_name: val })}
          />
        </div>
        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Chief Complaint"
            value={templates?.chief_complaint || ""}
            className="mycontentdivMain"
            error={form.chief_complaint}
            onChange={val => setTemplateData({ chief_complaint: val })}
          />
        </div>

        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Notes"
            value={templates?.notes || ""}
            className="mycontentdivMain"
            error={form.notes}
            onChange={val => setTemplateData({ notes: val })}
          />
        </div>
        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Assessment"
            value={templates?.assessment || ""}
            className="mycontentdivMain"
            error={form.assessment}
            onChange={val => setTemplateData({ assessment: val })}
          />
        </div>
        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Plan"
            value={templates?.plan || ""}
            className="mycontentdivMain"
            error={form.plan}
            onChange={val => setTemplateData({ plan: val })}
          />
        </div>

        <div className="col-md-4 d-flex justify-content-between align-items-center mt-2 px-2">
          <Button
            onClick={() => {
              validateData(templates);
            }}
            label="Save"
            className="mr-3"
          />
          <Button
            type="outline"
            label={"Cancel"}
            onClick={() => {
              history.goBack();
              clearTemplateData();
            }}
            className="btn-block"
          />
        </div>
      </div>
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation }) => ({
  templates: dashboard.templates.currentData,
  form: validation.data,
});

const mapDispatchToProps = dispatch => ({
  addTemplate: cb => dispatch(actions.addTemplate(cb)),
  setTemplateData: Data => dispatch(actions.setTemplateData(Data)),
  validateData: templates =>
    dispatch(actions.validateData(VALIDATE_TEMPLATE, templates)),
  clearTemplateData: () => dispatch(actions.clearTemplateData()),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(CreateNoteTemplate)
);
